const removeBracketsWithNumberFromTheEndOfTheString = (str: string): string =>
  str.replace(/\s?\(\d+\)$/, '')

export default removeBracketsWithNumberFromTheEndOfTheString
